export default [{
  label: 'Razão social', field: 'nome', editable: true, evento: null,
},
{ label: 'Procuração', field: 'porProcuracao' },
{ label: 'Status', field: 'status', type: 'custom' },
{ label: 'Vencimento', field: 'vencimento', type: 'custom' },
{ label: 'Inclusão', field: 'criadoEm', type: 'custom' }] // type: cutom
